export const PROBLEM_REPORT_FALLBACK = 'https://www.zyncdev.com/bug-melden?app=zyncfit';

export function problemReportHref(location) {
  const report = new URL(PROBLEM_REPORT_FALLBACK);
  if (!location) return report.href;
  try {
    const origin = new URL(location.origin);
    if (!['http:', 'https:'].includes(origin.protocol) || origin.origin !== location.origin || !location.pathname.startsWith('/')) return report.href;
    const page = new URL(`${origin.origin}${location.pathname}`);
    report.searchParams.set('url', page.origin + page.pathname);
  } catch { /* Keep the app-only link if no browser page is available. */ }
  return report.href;
}
